import {CommonModule} from '@angular/common';
import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {ModuleWithProviders, NgModule} from '@angular/core';
import {ApiModuleConfig} from '@tisa-group/cdk/models';
import {TisaUmpireHttpService} from './tisa-umpire-http.service';
import {UNDEFINED_UMPIRE_BASE_URL} from './tisa-umpire.errors';
import {TISA_UMPIRE_TOKEN, TISA_UMPIRE_URL} from './tisa-umpire.providers';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {ArticleService} from './article/article.service';
import {ClubService} from './club/club.service';
import {ComponentService} from './component/component.service';
import {CurrentPageService} from './current-page/current-page.service';
import {GroupService} from './group/group.service';
import {ImageService} from './image/image.service';
import {PublicationCategoryService} from './publication-category/publication-category.service';
import {RoundService} from './round/round.service';
import {SeasonService} from './season/season.service';
import {StageService} from './stage/stage.service';
import {TeamService} from './team/team.service';
import {MatchService} from './match/match.service';
import {SquadService} from './squad/squad.service';
import {StandingsService} from './standings/standings.service';
import {SquadPlayerService} from './squad-player/squad-player.service';
import {PlayerService} from './player/player.service';
import {CableService} from './cable/cable.service';
import {MatchStatsService} from './match-stats/match-stats.service';
import {LineupService} from './lineup/lineup.service';
import {SquadStatsService} from './squad-stats/squad-stats.service';
import {TransmissionProviderService} from './transmission-provider/transmission-provider.service';
import {VenueService} from './venue/venue.service';
import {CompetitionService} from './competition/competition.service';
import {CompetitionSeasonService} from './competition-season/competition-season.service';
import {StatisticsService} from './statistics/statistics.service';
import {IncidentService} from './incident/incident.service';
import {PushNotificationService} from './push-notification/push-notification.service';
import {RatingService} from './rating/rating.service';
import {TagService} from './tag/tag.service';
import {PageService} from './page/page.service';
import {PageTypeService} from './page-types/page-type.service';
import {QuizService} from './quiz/quiz.service';
import {QuizAnswerService} from './quiz-answer/quiz-answer.service';
import {QuizPrizeService} from './quiz-prize/quiz-prize.service';
import {QuizQuestionService} from './quiz-question/quiz-question.service';
import {QuizRankingService} from './quiz-ranking/quiz-ranking.service';
import {QuizUserAttemptService} from './quiz-user-attempt/quiz-user-attempt.service';
import {PushNotificationTargetService} from './push-notification-target/push-notification-target.service';
import {SponsorService} from './sponsor/sponsor.service';
import {ComponentTypesService} from './component-types/component-types.service';
import {OttEventService} from './ott-event/ott-event.service';
import {OttFormatService} from './ott-format/ott-format.service';
import {OttSegmentService} from './ott-segment/ott-segment.service';
import {OttPlaylistService} from './ott-playlist/ott-playlist.service';
import {OttStreamService} from './ott-stream/ott-stream.service';
import {OttClientPlaylistService} from './ott-client-playlist/ott-client-playlist.service';
import {SurveyService} from './survey/survey.service';
import {SurveyAnswerService} from './survey-answer/survey-answer.service';
import {StaffRolesService} from './staff-roles/staff-roles.service';
import {StaffMemberService} from './staff-member/staff-member.service';
import {SquadStaffMemberService} from './squad-staff-member/squad-staff-member.service';
import {VideoService} from './video/video.service';
import {OttFileUploadService} from './ott-file-upload/ott-file-upload.service';
import {OttMarkersService} from './ott-markers/ott-markers.service';
import {GlobalPageElementsService} from './global-page-elements/global-page-elements.service';
import {CurrentClientService} from './current-client/current-client.service';
import {CommentsService} from './comments/comments.service';
import {MatchPredictorRankingService} from './match-predictor-ranking/match-predictor-ranking.service';
import {ProductCategoryService} from './product-category/product-category.service';
import {FaqQuestionService} from './faq-question/faq-question.service';
import {ContactService} from './contact/contact.service';
import {OttDubbingService} from './ott-dubbing/ott-dubbing.service';
import {UmpireClientQuizService} from './client-quiz/umpire-client-quiz.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    TisaUmpireHttpService,
    ArticleService,
    ClubService,
    ComponentService,
    ContactService,
    CurrentPageService,
    GroupService,
    ImageService,
    LineupService,
    MatchService,
    OttEventService,
    OttDubbingService,
    OttFileUploadService,
    OttFormatService,
    OttPlaylistService,
    OttSegmentService,
    OttStreamService,
    OttMarkersService,
    PlayerService,
    PublicationCategoryService,
    RoundService,
    RatingService,
    SeasonService,
    SquadService,
    SquadPlayerService,
    SquadStaffMemberService,
    StageService,
    StatisticsService,
    StandingsService,
    TeamService,
    MatchService,
    StandingsService,
    CableService,
    MatchStatsService,
    SquadStatsService,
    TransmissionProviderService,
    VenueService,
    CompetitionService,
    CompetitionSeasonService,
    IncidentService,
    PushNotificationService,
    StaffMemberService,
    StaffRolesService,
    TagService,
    QuizService,
    QuizAnswerService,
    QuizPrizeService,
    QuizQuestionService,
    QuizRankingService,
    QuizUserAttemptService,
    PageService,
    PageTypeService,
    PushNotificationTargetService,
    SponsorService,
    ComponentTypesService,
    OttClientPlaylistService,
    SurveyService,
    SurveyAnswerService,
    VideoService,
    GlobalPageElementsService,
    CurrentClientService,
    CommentsService,
    MatchPredictorRankingService,
    ProductCategoryService,
    FaqQuestionService,
    UmpireClientQuizService,
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class TisaUmpireModule {
  static forRoot(config: ApiModuleConfig): ModuleWithProviders<TisaUmpireModule> {
    if (!config.api) throw UNDEFINED_UMPIRE_BASE_URL;

    return {
      ngModule: TisaUmpireModule,
      providers: [
        {
          provide: TISA_UMPIRE_URL,
          useValue: config.api,
        },
        {
          provide: TISA_UMPIRE_TOKEN,
          useFactory: (localStorage: Storage) => {
            return () => localStorage.getItem('TISA_TOKEN');
          },
          deps: [LOCAL_STORAGE],
        },
      ],
    };
  }
}
